import React, { useState } from "react";
import { Provinces, Districts, Sectors, Cells, Villages } from "rwanda";
import moment from "moment";
import StepperForm from "./StepperForm";
import { Alert, Box, Button } from "@mui/material";
import Modal from "../../src/components/Modal/Modal";
import StructureHierachy from "../../src/helpers/StructureHierachy";
import { connect } from "react-redux";
import { mapStateToProps } from "store/helpers/mapState";
import { mapDispatchToProps } from "store/helpers/mapDispatch";

const EmployeeForm = ({
  onSuccess,
  setOpen,
  open,
  structures,
}) => {
  const [locationData, setLocationData] = useState({
    provinces: Provinces(),
    districts: [],
    sectors: [],
    cells: [],
    villages: [],
  });

  const [fatherLocationData, setFatherLocationData] = useState({
    provinces: Provinces(),
    districts: [],
    sectors: [],
    cells: [],
    villages: [],
  });

  const [fatherInLawLocationData, setFatherInLawLocationData] = useState({
    provinces: Provinces(),
    districts: [],
    sectors: [],
    cells: [],
    villages: [],
  });

  const [motherInLawLocationData, setMotherInLawLocationData] = useState({
    provinces: Provinces(),
    districts: [],
    sectors: [],
    cells: [],
    villages: [],
  });

  const [motherLocationData, setMotherLocationData] = useState({
    provinces: Provinces(),
    districts: [],
    sectors: [],
    cells: [],
    villages: [],
  });

  const [activeStep, setActiveStep] = React.useState(0);
  const [value, setValue] = useState({});
  const [formError, setFormError] = useState(null);
  const [selectedStructure, setSelectedStructure] = useState();
  const [select, setSelect] = useState(false);
  const [structurePath, setStructurePath] = useState([]);


  const getChildren = (parent, allStructures) => {
    const parentId = parent?.id || null;
    return allStructures.filter(s => s.parentId === parentId);
  };

  const institutionOptions = getChildren(null, structures);

  const setValue0 = (name, val) => {
    if (!name) return null;

    setValue((prev) => {
      const updatedValues = {
        ...prev, // Copy all existing values
        [name]: val, // Update the specific field
      };

      if (name === "isMarried") {
        if (val === "no") {
          updatedValues["spouseName"] = "";
          updatedValues["fatherInLawName"] = "";
          updatedValues["motherInLawName"] = "";
          updatedValues["fatherInLawProvince"] = "";
          updatedValues["fatherInLawDistrict"] = "";
          updatedValues["fatherInLawSector"] = "";
          updatedValues["fatherInLawCell"] = "";
          updatedValues["fatherInLawVillage"] = "";
          updatedValues["fatherInLawHouseNo"] = "";
          updatedValues["fatherInLawStreet"] = "";
          updatedValues["fatherInLawVillageLeaderName"] = "";
          updatedValues["fatherInLawVillageLeaderMobile"] = "";
          updatedValues["motherInLawProvince"] = "";
          updatedValues["motherInLawDistrict"] = "";
          updatedValues["motherInLawSector"] = "";
          updatedValues["motherInLawCell"] = "";
          updatedValues["motherInLawVillage"] = "";
          updatedValues["motherInLawHouseNo"] = "";
          updatedValues["motherInLawStreet"] = "";
          updatedValues["motherInLawVillageLeaderName"] = "";
          updatedValues["motherInLawVillageLeaderMobile"] = "";
        } else {
          updatedValues["relationType"] = "spouse";
        }
      }
      return updatedValues;
    });
  };

  const steps = [
    {
      label: "Personal Information",
      fields: [
        {
          name: "surname",
          label: "Family name/surname",
          value: value["names"],
          required: true,
          setValue: (val) => setValue0("names", val),
        },
        {
          name: "firstname",
          label: "First name",
          value: value["names"],
          required: true,
          setValue: (val) => setValue0("names", val),
        },
        {
          name: "pseudoName",
          label: "pseudo name",
          value: value["names"],
          setValue: (val) => setValue0("names", val),
        },
        {
          name: "entryDate",
          label: "Entry Date at Imbuto Foundation",
          type: "date",
          value: value["entryDate"],
          required: true,
          maxDate: moment(),
          setValue: (val) => setValue0("entryDate", val),
        },
        {
          name: "gender",
          label: "Gender",
          type: "select",
          values: [
            { label: "Male", value: "male" },
            { label: "Female", value: "female" },
          ],
          value: value["gender"],
          required: true,
          setValue: (val) => setValue0("gender", val),
        },
        {
          name: "birthDate",
          label: "Date of Birth (DOB)",
          type: "date",
          value: value["birthDate"],
          required: true,
          maxDate: moment(),
          setValue: (val) => setValue0("birthDate", val),
        },
        {
          name: "placeOfBirth",
          label: "Place of Birth",
          type: "text",
          value: value["placeOfBirth"],
          required: true,
          setValue: (val) => setValue0("placeOfBirth", val),
        },
        {
          name: "phone",
          label: "Phone Number",
          type: "text",
          value: value["phone"],
          required: false,
          setValue: (val) => setValue0("qtPin", val),
        },
        {
          name: "email",
          label: "Email Address",
          type: "email",
          value: value["email"],
          required: true,
          setValue: (val) => setValue0("email", val),
        },

        {
          name: "province",
          label: "Province",
          type: "select",
          values: locationData.provinces.map((p) => ({ label: p, value: p })),
          setValue: (val) => {
            const districts = Districts(val);
            setLocationData((prev) => ({
              ...prev,
              districts,
              sectors: [],
              cells: [],
              villages: [],
            }));
            setValue0("province", val);
            setValue0("district", "");
            setValue0("sector", "");
            setValue0("cell", "");
            setValue0("village", "");
          },
        },

        {
          name: "district",
          label: "District",
          type: "select",
          values: locationData.districts.map((district) => ({
            label: district,
            value: district,
          })),
          setValue: (val) => {
        
            const sectors = Sectors(value.PlaceOfBirth?.province, val); // Pass province and district
            setLocationData((prev) => ({
              ...prev,
              sectors: sectors || [],
              cells: [],
              villages: [],
            }));

            setValue0("district", val);
            const fetchedSectors = Sectors(value["province"], val);
            setLocationData((prev) => ({
              ...prev,
              sectors: fetchedSectors || [],
              cells: [],
              villages: [],
            }));
            setValue0("sector", "");
            setValue0("cell", "");
            setValue0("village", "");
          },
        },
        {
          name: "sector",
          label: "Sector",
          type: "select",
          values: locationData.sectors.map((sector) => ({
            label: sector,
            value: sector,
          })),
          setValue: (val) => {
            const cells = Cells(value["province"], value["district"], val);

            setLocationData((prev) => ({
              ...prev,
              cells: cells || [],
              villages: [],
            }));
            setValue0("sector", val);
            setValue0("cell", "");
            setValue0("village", "");
          },
        },
        {
          name: "cell",
          label: "Cell",
          type: "select",
          values: locationData.cells.map((cell) => ({
            label: cell,
            value: cell,
          })),
          value: value["cell"],
          required: true,
          setValue: (val) => {
            const villages = Villages(
              value["province"],
              value["district"],
              value["sector"],
              val
            );

            setLocationData((prev) => ({
              ...prev,
              villages: villages || [],
            }));
            setValue0("cell", val);
            setValue0("village", "");
          },
        },
        {
          name: "village",
          label: "Village",
          type: "select",
          values: locationData.villages.map((village) => ({
            label: village,
            value: village,
          })),
          value: value["village"],
          required: true,
          setValue: (val) => setValue0("villages", val),
        },
        {
          name: "houseNo",
          label: "House No.",
          type: "text",
          value: value["houseNo"],
          required: true,
          setValue: (val) => setValue0("houseNo", val),
        },
        {
          name: "street",
          label: "Street",
          type: "text",
          value: value["street"],
          required: true,
          setValue: (val) => setValue0("street", val),
        },
        {
          name: "postalAddress",
          label: "Postal Address",
          type: "text",
          value: value["postalAddress"],
          // required: true,
          setValue: (val) => setValue0("postalAddress", val),
        },
        {
          name: "villageLeaderName",
          label: "Name of current village leader:",
          type: "text",
          value: value["villageLeaderName"],
          required: true,
          setValue: (val) => setValue0("villageLeaderName", val),
        },
        {
          name: "villageLeaderMobile",
          label: "Mobile number of current village leader:",
          type: "tel",
          value: value["villageLeaderMobile"],
          required: true,
          setValue: (val) => setValue0("villageLeaderMobile", val),
        },
        {
          name: "institution",
          label: "Institution",
          type: "select",
          values: institutionOptions.map(opt => ({ label: opt.name, value: opt.id })),
          value: structurePath[0]?.id || "",
          required: true,
          setValue: (val) => {
            const selected = institutionOptions.find(opt => opt.id === val);
            const newPath = selected ? [selected] : [];
            setStructurePath(newPath);
            setSelectedStructure(selected);
            setValue0("structureId", selected?.id || "");
          }
        },
        ...(structurePath[0]?.children?.length > 0 ? [{
          name: "office",
          label: "Office",
          type: "select",
          values: (structurePath[0]?.children || []).map(opt => ({ label: opt.name, value: opt.id })),
          value: structurePath[1]?.id || "",
          required: false,
          setValue: (val) => {
            const selected = structurePath[0]?.children?.find(opt => opt.id === val);
            const newPath = selected ? [structurePath[0], selected] : [structurePath[0]];
            setStructurePath(newPath);
            setSelectedStructure(selected || structurePath[0]);
            setValue0("structureId", selected ? selected.id : structurePath[0].id);
          }
        }] : []),
        ...(structurePath[1]?.children?.length > 0 ? [{
          name: "dipartment",
          label: structurePath[2]?.category || "Department",
          type: "select",
          values: (structurePath[1]?.children || []).map(opt => ({ label: opt.name, value: opt.id })),
          value: structurePath[2]?.id || "",
          required: false,
          setValue: (val) => {
            const selected = structurePath[1]?.children?.find(opt => opt.id === val);
            const newPath = selected ? [structurePath[0], structurePath[1], selected] : [structurePath[0], structurePath[1]];
            setStructurePath(newPath);
            setSelectedStructure(selected || structurePath[1]);
            setValue0("structureId", selected ? selected.id : structurePath[1].id);
          }
        }] : []),
        ...(structurePath[2]?.children?.length > 0 ? [{
          name: "division",
          label: structurePath[3]?.category || "Division",
          type: "select",
          values: (structurePath[2]?.children || []).map(opt => ({ label: opt.name, value: opt.id })),
          value: structurePath[3]?.id || "",
          required: false,
          setValue: (val) => {
            const selected = structurePath[2]?.children?.find(opt => opt.id === val);
            const newPath = selected ? [...structurePath.slice(0, 3), selected] : structurePath.slice(0, 3);
            setStructurePath(newPath);
            setSelectedStructure(selected || structurePath[2]);
            setValue0("structureId", selected ? selected.id : structurePath[2].id);
          }
        }] : []),
      ],
    },

    {
      label: "Diasporas Details",
      fields: [
        {
          name: "livedOutsideRwanda",
          label: "Have you and/or your parents ever lived outside Rwanda?",
          type: "radio",
          values: [
            { label: "Yes", value: "yes" },
            { label: "No", value: "no" },
          ],
          required: true,
          value: value["livedAbroad"],
          setValue: (val) => setValue0("livedAbroad", val),
        },
        {
          name: "country",
          label: "Which country?",
          type: "text",
          value: value["country"],
          setValue: (val) => setValue0("country", val),
          showIf: (values) => values["livedOutsideRwanda"] === "yes",
        },
        {
          name: "address",
          label: "Country Address",
          type: "text",
          value: value["address"],
          setValue: (val) => setValue0("address", val),
          showIf: (values) => values["livedOutsideRwanda"] === "yes",
        },
      ],
    },
    {
      label: "Civil Status",
      fields: [
        {
          name: "isMarried",
          label: "Are you married?",
          type: "radio",
          values: [
            { label: "Yes", value: "yes" },
            { label: "No", value: "no" },
          ],
          required: true,
          value: value["isMarried"],
          setValue: (val) => setValue0("isMarried", val),
        },
        {
          name: "relationType",
          value: "spouse",
          label: "Relation Type",
          hidden: true,
        },
        {
          name: "spouseName",
          label: "Name of your spouse",
          type: "text",
          value: value["spouseName"],
          setValue: (val) => setValue0("spouseName", val),
          required: value["isMarried"] === "yes",
          showIf: (values) => values["isMarried"] === "yes",
        },

        {
          name: "fatherInLawName",
          label: "Name of your father-in-law",
          type: "text",
          value: value["fatherInLawName"],
          setValue: (val) => setValue0("fatherInLawName", val),
          required: value["isMarried"] === "yes",
          showIf: (values) => values["isMarried"] === "yes",
        },
        {
          name: "motherInLawName",
          label: "Name of your mother-in-law",
          type: "text",
          value: value["motherInLawName"],
          required: value["isMarried"] === "yes",
          setValue: (val) => setValue0("motherInLawName", val),
          showIf: (values) => values["isMarried"] === "yes",
        },
        {
          name: "fatherInLawResidence",
          label: "FATHER-IN-LAW’S RESIDENCE",
          type: "group",
          style: {
            border: "1px solid #ccc",
            padding: "10px",
            borderRadius: "5px",
          },
          fields: [
            {
              name: "fatherInLawProvince",
              label: "Province",
              type: "select",
              values: fatherInLawLocationData.provinces.map((province) => ({
                label: province,
                value: province,
              })),
              required: value["isMarried"] === "yes",
              setValue: (val) => {
                const districts = Districts(val);
                setFatherInLawLocationData((prev) => ({
                  ...prev,
                  districts,
                  sectors: [],
                  cells: [],
                  villages: [],
                }));
                setValue0("fatherInLawProvince", val);
                setValue0("fatherInLawDistrict", "");
                setValue0("fatherInLawSector", "");
                setValue0("fatherInLawCell", "");
                setValue0("fatherInLawVillage", "");
              },
            },

            {
              name: "fatherInLawDistrict",
              label: "District",
              type: "select",
              values: fatherInLawLocationData.districts.map((district) => ({
                label: district,
                value: district,
              })),
              required: value["isMarried"] === "yes",
              setValue: (val) => {
                const sectors = Sectors(value["fatherInLawProvince"], val);
                setFatherInLawLocationData((prev) => ({
                  ...prev,
                  sectors: sectors || [],
                  cells: [],
                  villages: [],
                }));
                setValue0("fatherInLawDistrict", val);
                setValue0("fatherInLawSector", "");
                setValue0("fatherInLawCell", "");
                setValue0("fatherInLawVillage", "");
              },
            },
            {
              name: "fatherInLawSector",
              label: "Sector",
              type: "select",
              values: fatherInLawLocationData.sectors.map((sector) => ({
                label: sector,
                value: sector,
              })),
              required: value["isMarried"] === "yes",
              setValue: (val) => {
                const cells = Cells(
                  value["fatherInLawProvince"],
                  value["fatherInLawDistrict"],
                  val
                );
                setFatherInLawLocationData((prev) => ({
                  ...prev,
                  cells: cells || [],
                  villages: [],
                }));
                setValue0("fatherInLawSector", val);
                setValue0("fatherInLawCell", "");
                setValue0("fatherInLawVillage", "");
              },
            },
            {
              name: "fatherInLawCell",
              label: "Cell",
              type: "select",
              required: value["isMarried"] === "yes",
              values: fatherInLawLocationData.cells.map((cell) => ({
                label: cell,
                value: cell,
              })),
              setValue: (val) => {
                const villages = Villages(
                  value["fatherInLawProvince"],
                  value["fatherInLawDistrict"],
                  value["fatherInLawSector"],
                  val
                );
                setFatherInLawLocationData((prev) => ({
                  ...prev,
                  villages: villages || [],
                }));
                setValue0("fatherInLawCell", val);
                setValue0("fatherInLawVillage", "");
              },
            },
            {
              name: "fatherInLawVillage",
              label: "Village",
              type: "select",
              values: fatherInLawLocationData.villages.map((village) => ({
                label: village,
                value: village,
              })),
              setValue: (val) => setValue0("fatherInLawVillage", val),
            },
            {
              name: "fatherInLawHouseNo",
              label: "House No.",
              type: "text",
              value: value["fatherInLawHouseNo"],
              setValue: (val) => setValue0("fatherInLawHouseNo", val),
            },
            {
              name: "fatherInLawStreet",
              label: "Street",
              type: "text",
              value: value["fatherInLawStreet"],
              setValue: (val) => setValue0("fatherInLawStreet", val),
            },
            {
              name: "fatherInLawVillageLeaderName",
              label: "Name of fatherInLaw's village leader:",
              type: "text",
              value: value["fatherInLawVillageLeaderName"],
              setValue: (val) => setValue0("fatherInLawVillageLeaderName", val),
            },
            {
              name: "fatherInLawVillageLeaderMobile",
              label: "Mobile number of fatherInLaw's village leader:",
              type: "text",
              value: value["fatherInLawVillageLeaderMobile"],
              setValue: (val) =>
                setValue0("fatherInLawVillageLeaderMobile", val),
            },
          ],
          showIf: (values) => values["isMarried"] === "yes",
        },
        {
          name: "motherInLawResidence",
          label: "MOTHER-IN-LAW’S RESIDENCE",
          type: "group",
          style: {
            border: "1px solid #ccc",
            padding: "10px",
            borderRadius: "5px",
          },
          fields: [
            {
              name: "motherInLawProvince",
              label: "Province",
              type: "select",
              values: motherInLawLocationData.provinces.map((province) => ({
                label: province,
                value: province,
              })),
              setValue: (val) => {
                const districts = Districts(val);
                setMotherInLawLocationData((prev) => ({
                  ...prev,
                  districts,
                  sectors: [],
                  cells: [],
                  villages: [],
                }));
                setValue0("motherInLawProvince", val);
                setValue0("motherInLawDistrict", "");
                setValue0("motherInLawSector", "");
                setValue0("motherInLawCell", "");
                setValue0("motherInLawVillage", "");
              },
            },

            {
              name: "motherInLawDistrict",
              label: "District",
              type: "select",
              values: motherInLawLocationData.districts.map((district) => ({
                label: district,
                value: district,
              })),
              setValue: (val) => {
                const sectors = Sectors(value["motherInLawProvince"], val);
                setMotherInLawLocationData((prev) => ({
                  ...prev,
                  sectors: sectors || [],
                  cells: [],
                  villages: [],
                }));
                setValue0("motherInLawDistrict", val);
                setValue0("motherInLawSector", "");
                setValue0("motherInLawCell", "");
                setValue0("motherInLawVillage", "");
              },
            },
            {
              name: "motherInLawSector",
              label: "Sector",
              type: "select",
              values: motherInLawLocationData.sectors.map((sector) => ({
                label: sector,
                value: sector,
              })),
              setValue: (val) => {
                const cells = Cells(
                  value["motherInLawProvince"],
                  value["motherInLawDistrict"],
                  val
                );
                setMotherInLawLocationData((prev) => ({
                  ...prev,
                  cells: cells || [],
                  villages: [],
                }));
                setValue0("motherInLawSector", val);
                setValue0("motherInLawCell", "");
                setValue0("motherInLawVillage", "");
              },
            },
            {
              name: "motherInLawCell",
              label: "Cell",
              type: "select",
              values: motherInLawLocationData.cells.map((cell) => ({
                label: cell,
                value: cell,
              })),
              setValue: (val) => {
                const villages = Villages(
                  value["motherInLawProvince"],
                  value["motherInLawDistrict"],
                  value["motherInLawSector"],
                  val
                );
                setMotherInLawLocationData((prev) => ({
                  ...prev,
                  villages: villages || [],
                }));
                setValue0("motherInLawCell", val);
                setValue0("motherInLawVillage", "");
              },
            },
            {
              name: "motherInLawVillage",
              label: "Village",
              type: "select",
              values: motherInLawLocationData.villages.map((village) => ({
                label: village,
                value: village,
              })),
              setValue: (val) => setValue0("motherInLawVillage", val),
            },
            {
              name: "motherInLawHouseNo",
              label: "House No.",
              type: "text",
              value: value["motherInLawHouseNo"],
              setValue: (val) => setValue0("motherInLawHouseNo", val),
            },
            {
              name: "motherInLawStreet",
              label: "Street",
              type: "text",
              value: value["motherInLawStreet"],
              setValue: (val) => setValue0("motherInLawStreet", val),
            },
            {
              name: "motherInLawVillageLeaderName",
              label: "Name of motherInLaw's village leader:",
              type: "text",
              value: value["motherInLawVillageLeaderName"],
              setValue: (val) => setValue0("motherInLawVillageLeaderName", val),
            },
            {
              name: "motherInLawVillageLeaderMobile",
              label: "Mobile number of motherInLaw's village leader:",
              type: "text",
              value: value["motherInLawVillageLeaderMobile"],
              setValue: (val) =>
                setValue0("motherInLawVillageLeaderMobile", val),
            },
          ],
          showIf: (values) => values["isMarried"] === "yes",
        },
      ],
    },
    {
      label: "Relative Details",
      fields: [
        {
          name: "siblings",
          type: "array",
          label: "Siblings",

          itemLabel: (index, values) => {
            const type = values[index]?.type;
            if (!type) return "Sibling Type";
            const typeCount = values
              .slice(0, index + 1)
              .filter((v) => v.type === type).length;
            return `${type} #${typeCount}`;
          },
          fields: [
            {
              name: "relationType",
              label: "Sibling Type",
              type: "select",
              values: [
                { label: "Brother", value: "brother" },
                { label: "Sister", value: "sister" },
                { label: "Paternal Uncles", value: "paternal_uncle" },
                { label: "Maternal Uncles", value: "maternal_uncle" },
                { label: "Paternal Aunties", value: "paternal_aunt" },
                { label: "Maternal Aunties", value: "maternal_aunt" },
              ],
              value: value["relationType"],
              setValue: (val, index) => {
                const siblings = Array.isArray(value["siblings"])
                  ? value["siblings"]
                  : [];
                const updatedRecords = [...siblings];
                updatedRecords[index] = {
                  ...updatedRecords[index],
                  relationType: val,
                };
                setValue0("siblings", updatedRecords);
              },
              required: true,
            },
            {
              name: "name",
              label: "Full Name",
              type: "text",
              required: true,
            },
            {
              name: "country",
              label: "Country",
              type: "text",
              required: true,
            },

            {
              name: "phone",
              label: "Mob No",
              type: "text",
              required: true,
            },
            {
              name: "placeOfWork",
              label: "Place of Work",
              type: "text",
              required: true,
            },
          ],
        },
      ],
    },

    {
      label: "Parents Details",
      fields: [
        {
          name: "fatherName",
          label: "Names of your Father:",
          value: value["fatherName"],
          required: true,
          setValue: (val) => setValue0("fatherName", val),
        },
        {
          name: "motherName",
          label: "Name of your Mother",
          value: value["motherName"],
          required: true,
          setValue: (val) => setValue0("motherName", val),
        },
        {
          name: "parentsPlaceOfOrigin",
          label: "Parents place of Origin",
          value: value["parentsPlaceOfOrigin"],
          required: true,
          setValue: (val) => setValue0("parentsPlaceOfOrigin", val),
        },
        {
          name: "fatherOccupation",
          label: "Father occupation",
          type: "text",
          value: value["fatherOccupation"],
          required: true,
          setValue: (val) => setValue0("fatherOccupation", val),
        },
        {
          name: "motherOccupation",
          label: "Mother occupation",
          type: "text",
          value: value["motherOccupation"],
          required: true,
          setValue: (val) => setValue0("motherOccupation", val),
        },

        {
          name: "fatherResidence",
          label: "Father's Residence",
          type: "group",
          style: {
            border: "1px solid #ccc",
            padding: "10px",
            borderRadius: "5px",
          },
          fields: [
            {
              name: "fatherProvince",
              label: "Province",
              type: "select",
              required: true,
              values: locationData.provinces.map((province) => ({
                label: province,
                value: province,
              })),

              setValue: (val) => {
                const districts = Districts(val);
                setFatherLocationData((prev) => ({
                  ...prev,
                  districts,
                  sectors: [],
                  cells: [],
                  villages: [],
                }));
                setValue0("fatherProvince", val);
                setValue0("fatherDistrict", "");
                setValue0("fatherSector", "");
                setValue0("fatherCell", "");
                setValue0("fatherVillage", "");
              },
            },

            {
              name: "fatherDistrict",
              label: "District",
              type: "select",
              required: true,
              values: fatherLocationData.districts.map((district) => ({
                label: district,
                value: district,
              })),
              setValue: (val) => {
                const sectors = Sectors(value["fatherProvince"], val);
                setFatherLocationData((prev) => ({
                  ...prev,
                  sectors: sectors || [],
                  cells: [],
                  villages: [],
                }));
                setValue0("fatherDistrict", val);
                setValue0("fatherSector", "");
                setValue0("fatherCell", "");
                setValue0("fatherVillage", "");
              },
            },
            {
              name: "fatherSector",
              label: "Sector",
              type: "select",
              required: true,
              values: fatherLocationData.sectors.map((sector) => ({
                label: sector,
                value: sector,
              })),
              setValue: (val) => {
                const cells = Cells(
                  value["fatherProvince"],
                  value["fatherDistrict"],
                  val
                );
                setFatherLocationData((prev) => ({
                  ...prev,
                  cells: cells || [],
                  villages: [],
                }));
                setValue0("fatherSector", val);
                setValue0("fatherCell", "");
                setValue0("fatherVillage", "");
              },
            },
            {
              name: "fatherCell",
              label: "Cell",
              type: "select",
              required: true,
              values: fatherLocationData.cells.map((cell) => ({
                label: cell,
                value: cell,
              })),
              setValue: (val) => {
                const villages = Villages(
                  value["fatherProvince"],
                  value["fatherDistrict"],
                  value["fatherSector"],
                  val
                );
                setFatherLocationData((prev) => ({
                  ...prev,
                  villages: villages || [],
                }));
                setValue0("fatherCell", val);
                setValue0("fatherVillage", "");
              },
            },
            {
              name: "fatherVillage",
              label: "Village",
              type: "select",
              required: true,
              values: fatherLocationData.villages.map((village) => ({
                label: village,
                value: village,
              })),
              setValue: (val) => setValue0("fatherVillage", val),
            },
            {
              name: "fatherHouseNo",
              label: "House No.",
              type: "text",
              required: true,
              value: value["fatherHouseNo"],
              setValue: (val) => setValue0("fatherHouseNo", val),
            },
            {
              name: "fatherStreet",
              label: "Street",
              type: "text",
              required: true,
              value: value["fatherStreet"],
              setValue: (val) => setValue0("fatherStreet", val),
            },
            {
              name: "fatherPostalAddress",
              label: "Postal Address",
              type: "text",
              value: value["fatherPostalAddress"],
              setValue: (val) => setValue0("fatherPostalAddress", val),
            },
            {
              name: "fatherVillageLeaderName",
              label: "Name of Father's village leader:",
              type: "text",
              required: true,
              value: value["fatherVillageLeaderName"],
              setValue: (val) => setValue0("fatherVillageLeaderName", val),
            },
            {
              name: "fatherVillageLeaderMobile",
              label: "Mobile number of Father's village leader:",
              type: "text",
              value: value["fatherVillageLeaderMobile"],
              setValue: (val) => setValue0("fatherVillageLeaderMobile", val),
            },
          ],
        },

        {
          name: "motherResidence",
          label: "Mother's Residence",
          type: "group",
          style: {
            border: "1px solid #ccc",
            padding: "10px",
            borderRadius: "5px",
          },
          fields: [
            {
              name: "motherProvince",
              label: "Province",
              type: "select",
              required: true,
              values: locationData.provinces.map((province) => ({
                label: province,
                value: province,
              })),
              setValue: (val) => {
                const districts = Districts(val);
                setLocationData((prev) => ({
                  ...prev,
                  districts,
                  sectors: [],
                  cells: [],
                  villages: [],
                }));
                setValue0("motherProvince", val);
                setValue0("motherDistrict", "");
                setValue0("motherSector", "");
                setValue0("motherCell", "");
                setValue0("motherVillage", "");
              },
            },

            {
              name: "motherDistrict",
              label: "District",
              type: "select",
              required: true,
              values: locationData.districts.map((district) => ({
                label: district,
                value: district,
              })),
              setValue: (val) => {
                const sectors = Sectors(value["motherProvince"], val);
                setLocationData((prev) => ({
                  ...prev,
                  sectors: sectors || [],
                  cells: [],
                  villages: [],
                }));
                setValue0("motherDistrict", val);
                setValue0("motherSector", "");
                setValue0("motherCell", "");
                setValue0("motherVillage", "");
              },
            },
            {
              name: "motherSector",
              label: "Sector",
              type: "select",
              required: true,
              values: locationData.sectors.map((sector) => ({
                label: sector,
                value: sector,
              })),
              setValue: (val) => {
                const cells = Cells(
                  value["motherProvince"],
                  value["motherDistrict"],
                  val
                );
                setLocationData((prev) => ({
                  ...prev,
                  cells: cells || [],
                  villages: [],
                }));
                setValue0("motherSector", val);
                setValue0("motherCell", "");
                setValue0("motherVillage", "");
              },
            },
            {
              name: "motherCell",
              label: "Cell",
              type: "select",
              required: true,
              values: locationData.cells.map((cell) => ({
                label: cell,
                value: cell,
              })),
              setValue: (val) => {
                const villages = Villages(
                  value["motherProvince"],
                  value["motherDistrict"],
                  value["motherSector"],
                  val
                );
                setLocationData((prev) => ({
                  ...prev,
                  villages: villages || [],
                }));
                setValue0("motherCell", val);
                setValue0("motherVillage", "");
              },
            },
            {
              name: "motherVillage",
              label: "Village",
              type: "select",
              required: true,
              values: locationData.villages.map((village) => ({
                label: village,
                value: village,
              })),
              setValue: (val) => setValue0("motherVillage", val),
            },
            {
              name: "motherHouseNo",
              label: "House No.",
              type: "text",
              required: true,
              value: value["motherHouseNo"],
              setValue: (val) => setValue0("motherHouseNo", val),
            },
            {
              name: "motherStreet",
              label: "Street",
              type: "text",
              required: true,
              value: value["motherStreet"],
              setValue: (val) => setValue0("motherStreet", val),
            },
            {
              name: "motherPostalAddress",
              label: "Postal Address",
              type: "text",
              required: true,
              value: value["motherPostalAddress"],
              setValue: (val) => setValue0("motherPostalAddress", val),
            },
            {
              name: "motherVillageLeaderName",
              label: "Name of Mother's village leader:",
              type: "text",
              required: true,
              value: value["motherVillageLeaderName"],
              setValue: (val) => setValue0("motherVillageLeaderName", val),
            },
            {
              name: "motherVillageLeaderMobile",
              label: "Mobile number of Mother's village leader:",
              type: "text",
              required: true,
              value: value["motherVillageLeaderMobile"],
              setValue: (val) => setValue0("motherVillageLeaderMobile", val),
            },
          ],
        },
      ],
    },

    {
      label: "Criminal Record",
      fields: [
        {
          name: "beenImprisoned",
          label: "Have you been imprisoned?",
          type: "radio",
          values: [
            { label: "Yes", value: "yes" },
            { label: "No", value: "no" },
          ],
          value: value["beenImprisoned"],
          setValue: (val) => {
            setValue0("beenImprisoned", val);
            if (val === "no") {
              setValue0("imprisonmentDetails", "");
              setValue0("imprisonmentDuration", "");
            }
          },
          required: true,
        },
        {
          name: "startDate",
          label: "Date of imprisonment",
          type: "date",
          value: value["startDate"],
          setValue: (val) => {
            setValue0("startDate", val);
          },
          showIf: (values) => values?.beenImprisoned === "yes",
        },
        {
          name: "endDate",
          label: "End date of imprisonment",
          type: "date",
          value: value["endDate"],
          setValue: (val) => {
            setValue0("endDate", val);
          },
          showIf: (values) => values?.beenImprisoned === "yes",
        },
        {
          name: "location",
          label: "Location of imprisonment",
          type: "text",
          value: value["location"],
          setValue: (val) => setValue0("location", val),
          showIf: (values) => values?.beenImprisoned === "yes",
        },
        {
          name: "imprisonmentReason",
          label: "Reason for imprisonment",
          type: "text",
          value: value["imprisonmentReason"],
          setValue: (val) => setValue0("imprisonmentReason", val),
          showIf: (values) => values?.beenImprisoned === "yes",
        },
      ],
    },
    {
      label: "Education Record",
      fields: [
        {
          name: "educationRecords",
          label: "Education Institutions (Start with the most recent)",
          type: "array",
          value: value["educationRecords"],
          setValue: (val) => setValue0("educationRecords", val),

          itemLabel: (index, values) => {
            const record = values[index];
            return `Education #${index + 1}`;
          },
          fields: [
            {
              name: "institution",
              label: "Education Institution",
              type: "text",
              required: true,
              value: value["institution"],
              setValue: (val, index) => {
                const educationRecords = Array.isArray(
                  value["educationRecords"]
                )
                  ? value["educationRecords"]
                  : [];
                const updatedRecords = [...educationRecords];
                updatedRecords[index] = {
                  ...updatedRecords[index],
                  institution: val,
                };
                setValue0("educationRecords", updatedRecords);
              },
            },
            {
              name: "location",
              label: "Location",
              type: "text",
              required: true,
              value: value["location"],
              setValue: (val, index) => {
                const educationRecords = Array.isArray(
                  value["educationRecords"]
                )
                  ? value["educationRecords"]
                  : [];
                const updatedRecords = [...educationRecords];
                updatedRecords[index] = {
                  ...updatedRecords[index],
                  location: val,
                };
                setValue0("educationRecords", updatedRecords);
              },
            },
            {
              name: "fieldOfStudy",
              label: "Major Field of Study",
              type: "text",
              required: true,
              value: value["fieldOfStudy"],
              setValue: (val, index) => {
                const educationRecords = Array.isArray(
                  value["educationRecords"]
                )
                  ? value["educationRecords"]
                  : [];
                const updatedRecords = [...educationRecords];
                updatedRecords[index] = {
                  ...updatedRecords[index],
                  fieldOfStudy: val,
                };
                setValue0("educationRecords", updatedRecords);
              },
            },
            {
              name: "degreeDiploma",
              label: "Degree/Diploma",
              type: "text",
              required: true,
              value: value["degreeDiploma"],
              setValue: (val, index) => {
                const educationRecords = Array.isArray(
                  value["educationRecords"]
                )
                  ? value["educationRecords"]
                  : [];
                const updatedRecords = [...educationRecords];
                updatedRecords[index] = {
                  ...updatedRecords[index],
                  degreeDiploma: val,
                };
                setValue0("educationRecords", updatedRecords);
              },
            },
            {
              name: "classOfDegree",
              label: "Class of Degree",
              type: "text",
              required: true,
              value: value["classOfDegree"],
              setValue: (val, index) => {
                const educationRecords = Array.isArray(
                  value["educationRecords"]
                )
                  ? value["educationRecords"]
                  : [];
                const updatedRecords = [...educationRecords];
                updatedRecords[index] = {
                  ...updatedRecords[index],
                  classOfDegree: val,
                };
                setValue0("educationRecords", updatedRecords);
              },
            },
            {
              name: "startYear",
              label: "Started At",
              type: "date",
              required: true,
              value: value["startYear"],
              setValue: (val) => {
                setValue0("startYear", val);
              },
            },
            {
              name: "endYear",
              label: "Ended At",
              type: "date",
              required: true,
              value: value["endYear"],
              setValue: (val) => {
                setValue0("endYear", val);
              },
            },
          ],
        },
      ],
    },

    {
      label: "Relative In Leadership Position",
      fields: [
        {
          name: "leadershipPosition",
          label: "do you have any relative in leadership position?",
          type: "radio",
          values: [
            { label: "Yes", value: "yes" },
            { label: "No", value: "no" },
          ],
          value: value["leadershipPosition"],
          setValue: (val) => setValue0("leadershipPosition", val),
        },

        {
          name: "leaderName",
          label: "Name",
          type: "text",
          required: true,
          value: value["leaderName"],
          setValue: (val) => setValue0("leaderName", val),
          showIf: (values) => values["leadershipPosition"] === "yes",
        },
        {
          name: "leaderRelationship",
          label: "Relationship",
          type: "text",
          value: value["leaderRelationship"],
          setValue: (val) => setValue0("leaderRelationship", val),
          showIf: (values) => values["leadershipPosition"] === "yes",
        },
        {
          name: "position",
          label: " Position",
          type: "text",
          value: value["position"],
          setValue: (val) => setValue0("position", val),
          showIf: (values) => values["leadershipPosition"] === "yes",
        },
        {
          name: "isAbroad",
          label:
            "Do you have a relative who served in the current government in leadership position who is currently living abroad whether on an official assignment or not?",
          type: "radio",
          values: [
            { label: "Yes", value: "yes" },
            { label: "No", value: "no" },
          ],
          value: value["isAbroad"],
          setValue: (val) => setValue0("isAbroad", val),
        },

        {
          name: "abroadName",
          label: "Name",
          type: "text",
          value: value["abroadName"],
          setValue: (val) => setValue0("abroadName", val),
          showIf: (values) => values["isAbroad"] === "yes",
        },
        {
          name: "abroadRelationship",
          label: "Relationship",
          type: "text",
          value: value["abroadRelationship"],
          setValue: (val) => setValue0("abroadRelationship", val),
          showIf: (values) => values["isAbroad"] === "yes",
        },
      ],
    },

    {
      label: "Employement History",
      fields: [
        {
          name: "employementRecords",
          label: "Employement History (Start with the most recent)",
          type: "array",
          value: value["employementRecords"],
          setValue: (val) => setValue0("employementRecords", val),

          itemLabel: (index, values) => {
            const record = values[index];
            return `Employement #${index + 1}`;
          },
          fields: [
            {
              name: "companyName",
              label: "Company Name",
              type: "text",
              value: value["companyName"],
              setValue: (val, index) => {
                const employementRecords = Array.isArray(
                  value["employementRecords"]
                )
                  ? value["employementRecords"]
                  : [];
                const updatedRecords = [...employementRecords];
                updatedRecords[index] = {
                  ...updatedRecords[index],
                  companyName: val,
                };
                setValue0("employementRecords", updatedRecords);
              },
            },
            {
              name: "employerName",
              label: "Employer Name",
              type: "text",
              value: value["employerName"],
              setValue: (val, index) => {
                const employementRecords = Array.isArray(
                  value["employementRecords"]
                )
                  ? value["employementRecords"]
                  : [];
                const updatedRecords = [...employementRecords];
                updatedRecords[index] = {
                  ...updatedRecords[index],
                  employerName: val,
                };
                setValue0("employementRecords", updatedRecords);
              },
            },
            {
              name: "employerMobile",
              label: "Employer Mobile",
              type: "text",
              value: value["employerMobile"],
              setValue: (val, index) => {
                const employementRecords = Array.isArray(
                  value["employementRecords"]
                )
                  ? value["employementRecords"]
                  : [];
                const updatedRecords = [...employementRecords];
                updatedRecords[index] = {
                  ...updatedRecords[index],
                  employerMobile: val,
                };
                setValue0("employementRecords", updatedRecords);
              },
            },
            {
              name: "position",
              label: "Employement Position",
              type: "text",
              value: value["position"],
              setValue: (val, index) => {
                const employementRecords = Array.isArray(
                  value["employementRecords"]
                )
                  ? value["employementRecords"]
                  : [];
                const updatedRecords = [...employementRecords];
                updatedRecords[index] = {
                  ...updatedRecords[index],
                  position: val,
                };
                setValue0("employementRecords", updatedRecords);
              },
            },
            {
              name: "jobStartDate",
              label: "Started At",
              type: "date",
              value: value["jobStartDate"],
              setValue: (val) => {
                setValue0("jobStartDate", val);
              },
            },
            {
              name: "jobEndDate",
              label: "Ended At",
              type: "date",
              value: value["jobEndDate"],
              setValue: (val) => {
                setValue0("jobEndDate", val);
              },
            },
          ],
        },
      ],
    },
    {
      label: "Referees",
      fields: [
        {
          name: "referees",
          label: "Referees",
          type: "array",
          value: value["referees"],
          setValue: (val) => setValue0("referees", val),

          itemLabel: (index, values) => {
            const record = values[index];
            return `Referee #${index + 1}`;
          },
          fields: [
            {
              name: "refereName",
              label: "Name",
              type: "text",
              required: true,
              value: value["refereName"],
              setValue: (val, index) => {
                const referees = Array.isArray(value["referees"])
                  ? value["referees"]
                  : [];
                const updatedRecords = [...referees];
                updatedRecords[index] = { ...updatedRecords[index], name: val };
                setValue0("referees", updatedRecords);
              },
            },
            {
              name: "refereAddress",
              label: "Address",
              type: "text",
              required: true,
              value: value["refereAddress"],
              setValue: (val, index) => {
                const referees = Array.isArray(value["referees"])
                  ? value["referees"]
                  : [];
                const updatedRecords = [...referees];
                updatedRecords[index] = {
                  ...updatedRecords[index],
                  address: val,
                };
                setValue0("referees", updatedRecords);
              },
            },
            {
              name: "referePhone",
              label: "Phone Number",
              type: "text",
              required: true,
              value: value["referePhone"],
              setValue: (val, index) => {
                const referees = Array.isArray(value["referees"])
                  ? value["referees"]
                  : [];
                const updatedRecords = [...referees];
                updatedRecords[index] = {
                  ...updatedRecords[index],
                  phone: val,
                };
                setValue0("referees", updatedRecords);
              },
            },
            {
              name: "refereRelationship",
              label: "Relationship",
              type: "select",
              required: true,
              values: [
                { value: "professional", label: "Professional" },
                { value: "academic", label: "Academic" },
                { value: "personal", label: "Personal" },
                { value: "other", label: "Other" },
              ],
              value: value["refereRelationship"],
              setValue: (val, index) => {
                const referees = Array.isArray(value["referees"])
                  ? value["referees"]
                  : [];
                const updatedRecords = [...referees];
                updatedRecords[index] = {
                  ...updatedRecords[index],
                  relationship: val,
                };
                setValue0("referees", updatedRecords);
              },
            },
            {
              name: "customRelationship",
              label: "Specify Relationship",
              type: "text",

              value: value["customRelationship"],
              setValue: (val, index) => {
                const referees = Array.isArray(value["referees"])
                  ? value["referees"]
                  : [];
                const updatedRecords = [...referees];
                updatedRecords[index] = {
                  ...updatedRecords[index],
                  customRelationship: val,
                };
                setValue0("referees", updatedRecords);
              },
              showIf: (values, index) => {
                const referees = Array.isArray(values["referees"])
                  ? values["referees"]
                  : [];

                return referees[index]?.refereRelationship === "other";
              },
            },
          ],
        },
      ],
    },
  ];

  const handleNext = () => {
    setActiveStep(1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <StepperForm
      handleNext={handleNext}
      handleBack={handleBack}
      maxWidth={"lg"}
      col={6}
      open={open > 0}
      onSuccess={(resp) => {

        if (typeof onSuccess === "function") onSuccess(resp);
        window.location.href = "/admin/if-structure";
      }}
      setOpen={setOpen}
      title={open === 1 ? "Create New Employee" : "Edit Employee"}
      steps={steps}
      activeStep={activeStep}
      customActions={
        <>
          <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
            {formError && (
              <Alert severity="error" sx={{ mb: 2, width: "100%" }}>
                {formError}
              </Alert>
            )}
            <Button
              color="inherit"
              disabled={activeStep === 0}
              onClick={handleBack}
              sx={{ mr: 1 }}
            >
              Back
            </Button>
            <Box sx={{ flex: "1 1 auto" }} />
            {activeStep === steps.length - 1 ? (
              <Button type="submit" variant="contained" color="primary">
                Submit
              </Button>
            ) : (
              <button
                color="primary"
                disabled={activeStep === steps.length + 1}
                onClick={handleNext}
                sx={{ mr: 1 }}
              >
                Next
              </button>
            )}
          </Box>

          <Modal
            maxWidth={"sm"}
            title={selectedStructure ? `${selectedStructure?.category}: ${selectedStructure?.name}` : "Select Structure"}
            select={select}
            setSelect={setSelect}
          >
            <StructureHierachy
              structures={structures}
              setSelectedStructure={setSelectedStructure}
            />
          </Modal>
        </>
      }
    />
  );
}
export default connect(mapStateToProps, mapDispatchToProps)(EmployeeForm);
